export default (
  state = {
    isPostingReminder: false,
    reminderSuccessfull: false,
    error: '',
  },
  action,
) => {
  switch (action.type) {
    case 'IS_POSTING_REMINDER':
      return {
        ...state,
        isPostingReminder: true,
      };
    case 'REMINDER_FAILURE':
      return {
        ...state,
        isPostingReminder: false,
        error: action.error,
      };
    case 'REMINDER_SUCCESS':
      return {
        ...state,
        isPostingReminder: false,
        reminderSuccessfull: true,
        error: '',
      };
    case 'RESET_REMINDER':
      return {
        isPostingReminder: false,
        reminderSuccessfull: false,
        error: '',
      };
    default:
      return state;
  }
};
